// extracted by mini-css-extract-plugin
module.exports = {"white":"RichContent_white_18hPH","small":"RichContent_small_d9q_s","big":"RichContent_big_3J_fc","android":"RichContent_android_23VI2"};